import { boolean, z } from "zod";

//QualidadeCronogramaSGQSchema

const optionalString = z.string().nullable().optional();
const optionalValor = z.coerce.string().nullable().default(null).transform(x => {
  return x !== null && x !== undefined && x.trim().length > 0 ? Number(x) : null;
});

export const QualidadeCronogramaSGQSchema = z.object({
    IdCronogramaSGQ: z.number().int().nullable().optional(), 
    Item: z.number().int().nullable().optional(),
    IdFuncionario: z.number().int().nullable().optional(),
    IdCentro_custo: z.number().int().nullable().optional(),
    Atividade: optionalString,
    DescResponsavel: optionalString,
    Observacao: optionalString,
    ResponsavelCadastrado: z.coerce.boolean().nullable().optional(), 
    DataPrevista: z.coerce.date().nullable().optional(),
    DataRealizada: z.coerce.date().nullable().optional(),
    DataPrevistaReal: z.coerce.date().nullable().optional(),
    DataRealizadaReal: z.coerce.date().nullable().optional(),
    ValorPrevisto: optionalValor,
    ValorRealizado: optionalValor,
});

// QualidadeCronogramaSGQForm

export type QualidadeCronogramaSGQForm = z.infer<typeof QualidadeCronogramaSGQSchema>;